// extracted by mini-css-extract-plugin
export var aboveInput = "_ki-0";
export var actionButton = "_ki-5";
export var actionButtonContainer = "_ki-1";
export var actionIcon = "_ki-6";
export var aiInfoContainer = "_ki-2";
export var attachmentWrapper = "_ki-7";
export var bold = "_ki-3";
export var checkIcon = "_ki-8";
export var clickingRecipientBar = "_ki-11";
export var commentThreadSwitch = "_ki-a";
export var draftImage = "_ki-b";
export var draftImageContainer = "_ki-c";
export var draftImages = "_ki-e";
export var editButton = "_ki-g";
export var editor = "_ki-f";
export var editorContainer = "_ki-y";
export var editorErrorTooltipWrapper = "_ki-9";
export var headerDivider = "_ki-h";
export var icon = "_ki-i";
export var info = "_ki-j";
export var internal = "_ki-n";
export var internalDivider = "_ki-k";
export var internalMessage = "_ki-l";
export var messageInputCard = "_ki-m";
export var messageInputForm = "_ki-o";
export var messageInputFormInternal = "_ki-p";
export var options = "_ki-q";
export var publicMessageCustomer = "_ki-s";
export var publicMessageMerchant = "_ki-r";
export var removeImageButton = "_ki-d";
export var replyButtons = "_ki-t";
export var showSignatureButton = "_ki-u";
export var spinner = "_ki-v";
export var verticalButtonDivider = "_ki-4";
export var visibilitySelector = "_ki-w";
export var warning = "_ki-x";
export var wrappingText = "_ki-z";
export var writingInternalNoteTopBorder = "_ki-10";